import styled, { css } from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import bin from '~/static/images/videocontrol/steps-install/bin.svg';
import minus from '~/static/images/videocontrol/steps-install/minus.svg';
import plus from '~/static/images/videocontrol/steps-install/plus.svg';

const resetStyleButton = css`
    background: transparent;
    border: none;
    margin: 0;
    outline: none;
`;

export const Container = styled.div`
    width: 100%;
    gap: 8px;
    border-bottom: 1px solid;
    border-color: ${COLORS.TextInfo};
    padding-bottom: 8px;
`;

export const ShopTitle = styled.h4`
    width: 100%;
    ${FONTS.H4};
    color: ${COLORS.TextWhite};
`;

export const ProductName = styled.span`
    ${FONTS.M};
    color: ${COLORS.TextWhite};
`;

export const DeleteButton = styled.button`
    ${resetStyleButton};
    width: 20px;
    height: 20px;
    background-image: url('${bin}');
    background-repeat: no-repeat;
    background-position: center;
    cursor: pointer;
`;

export const ProductNameWrap = styled.div`
    width: 100%;
    justify-content: space-between;
`;

export const WrapSubService = styled.div`
    width: 100%;
`;

export const SubService = styled.span`
    ${FONTS.XS};
    color: ${COLORS.GRAY_LIGHT};
`;

export const Service = styled.span`
    ${FONTS.S};
    color: ${COLORS.GRAY_LIGHT};

    @media (max-width: ${wideBreakpoints.mobile}) {
        width: 120px;
    }
`;

export const PriceWrap = styled.div`
    gap: 16px;

    @media (max-width: 400px) {
        flex-direction: column-reverse;
        gap: 0;
    }
`;

export const Price = styled.span`
    ${FONTS.S};
    color: ${COLORS.GRAY_LIGHT};
`;

export const OldPrice = styled.s`
    ${FONTS.S};
    color: ${COLORS.GRAY_LIGHT};
`;

export const ServiceWrap = styled.div`
    width: 100%;
    justify-content: space-between;
  
    @media (max-width: ${wideBreakpoints.mobile}) {
        align-items: flex-end;
    }
`;

export const Counter = styled.div<{isDisabled: boolean}>`
    width: 101px;
    height: 28px;
    align-items: center;
    justify-content: space-between;
    border-radius: 20px;
    padding: 0 18px;
    ${FONTS.S};
    background-color: ${(p) => p.isDisabled ? COLORS.TextDisabled : COLORS.BgLight};
    pointer-events: ${(p) => p.isDisabled ? 'none' : 'default'};
`;

export const Plus = styled.button`
    ${resetStyleButton};
    width: 14px;
    height: 14px;
    background: url('${plus}') no-repeat center;
    cursor: pointer;
`;

export const Minus = styled.button`
    ${resetStyleButton};
    width: 14px;
    height: 14px;
    background: url('${minus}') no-repeat center;
    cursor: pointer;
`;

export const CountValue = styled.span`
    flex-grow: 1;
    text-align: center;
`;

export const CounterWrap = styled.div`
    gap: 24px;
    align-items: center;
`;
